<template>
  <div id="app" v-loading="loading">
    <template v-if="!loading">
      <router-view />
    </template>

    <wxShare ref="wxShareRef"></wxShare>
    <div class="back" v-if="!isMiniProgram && isMyApp && !hiddenBackIcon">
      <span class="circle" @click="onBack"> </span>
    </div>
    <div v-if="isPreview" class="preview">
      <div class="left-line"></div>
      <div class="tips">预览页面 请勿分享</div>
      <div class="right-line"></div>
    </div>
  </div>
</template>

<script>
import ClientApi from "@/common/js/bridge/ClientApi.js";
import { mapMutations, mapState } from "vuex";
import { getCookie } from "@/common/js/cookie";
import { oss } from "@/api/basic/oss/index";
import { brower, openInWXMiniprogram } from "@/common/wxJs/wx-util";
import wxShare from "@/components/view/wxShare";
import { wxApi } from "@/api/basic/wx/index";
import loginMixin from "@/common/js/mixin/loginMixin";
import { EventBus } from "@/eventBus.js";
import { initTianrongTracking, PZH_APP_ID } from "@/common/js/tianrongTracking.js";
export default {
  name: "App",
  data() {
    return {
      id: "",
      appId: "",
      query: {},
      show: false,
      loading: true,
      appJson: {},
      // 是否开启sdk
      isOutSdk: 0,
      openId: "", //冀时办使用-如果openId存在（一级页面跳转-走freelogin）不存在(二级页面跳转-跳过freelogin)
    };
  },
  components: {
    wxShare,
  },
  mixins: [loginMixin],
  computed: {
    ...mapState(["isMyApp", "isPreview", "indexJson", "isMiniProgram"]),
    hiddenBackIcon() {
      return this.appId === "ebdc6f032a244ec98373becd2fc6d5d2";
    },
  },
  created() {
    if (this.$appCommonH.getRequestParamObj().appId === PZH_APP_ID) {
      initTianrongTracking({
        configOptions: {
          // SDK URL 参数 an 对应的应用名称，会随初始化脚本一起传给 SDK。
          appName: "报名",
        },
        // PDF 的 load 事件要求业务标题；这里动态获取，兼容报名、抽奖、赛事等页面。
        getPageViewEventParam: () => ({
          title: '报名',
          sourceId: this.$appCommonH.getRequestParamObj().id || "",
        }),
        // cio.init 执行完成，表示 SDK 基础配置已经初始化。
        onReady() {
          console.log("[天融埋点] SDK 初始化完成");
        },
        // eventId=2、eventType=load 已进入 SDK 队列，表示访问量事件已提交。
        onQueued(info) {
          console.log("[天融埋点] 访问量事件已入队", info);
        },
        // SDK 实际发送批量请求并收到响应时触发，首次事件不一定立即触发。
        onTrackResponse(response) {
          console.log("[天融埋点] 埋点请求响应", response);
        },
        // 配置缺失、SDK 加载失败或初始化失败时触发。
        onError(error) {
          console.error("[天融埋点] SDK 初始化或埋点失败", error);
        },
      }).catch(() => {});
    }
    window.localStorage.setItem("captchaId", "");
    this.WebApi.getInstance().subscribeAction("callback", (res) => {});
    this.initSliderSdk();
    this.initParam();
    this.initCookie();
    this.initApp();
  },
  mounted() {
    let script = document.createElement("script");
    // script.src = 'https://activity.platform.xinhuaapp.com/statics/xy-h5-tool/index.js' // 测试环境
    script.src = "https://activity.xinhuamm.net/statics/xy-h5-tool/index.js"; // 正式环境
    document.head.appendChild(script);
  },
  methods: {
    ...mapMutations({
      setAppJosn: "SET_APP_JSON",
      setIndexJson: "SET_INDEX_JSON",
      setCookieJson: "SET_COOKIE_JSON",
      setIsMyApp: "SET_IS_MYAPP",
      setIsPreivie: "SET_IS_PREVIEW",
      setIsMiniProgram: "SET_IS_MINIPROGRAM",
    }),
    /**
     * 获取地址参数
     */
    initParam() {
      this.query = this.$appCommonH.getRequestParamObj();
      this.id = this.query.id;
      this.appId = this.query.appId;
      this.openId = this.query.openId || "";
      console.log("this.query", this.query);
      for (let key in this.query) {
        if (key.includes("identity")) {
          localStorage.setItem(
            "identityObj",
            JSON.stringify({
              id: this.query.id,
              identity: this.query[key],
            })
          );
        } else {
          localStorage.setItem(key, this.query[key]);
        }
      }
    },
    /**
     * 获取用户信息
     */
    initCookie() {
      const tk = getCookie("token");
      const userInToken = tk ? window.xhCloud.outSdkUtils.decodeJwtToken(tk) : ""; // 从token中获取用户信息
      if (userInToken) {
        this.setCookieJson(userInToken.userInfo);
      } else {
        let userInfo = decodeURIComponent(getCookie("user"));
        if (userInfo) {
          this.setCookieJson(JSON.parse(userInfo));
        }
      }
    },
    initApp() {
      this.setIsPreivie(this.$appCommonH.getDataByKey("preview"));
      //是否是预览页
      if (this.isPreview) {
        this.getJsonFromPreview();
      } else {
        if (this.id && this.appId) {
          this.getPageJson();
        } else {
          this.loading = false;
        }
      }
    },
    /**
     * 获取预览页面数据
     */
    getJsonFromPreview() {
      oss.getJsonFromPreview({}, this.id, this.query.timeNo).then((res) => {
        this.setIndexJson(res.data);
        this.$appCommonH.setMainColor(res.data.bgColor);
        this.loading = false;
      });
    },
    //获取页面数据
    getPageJson() {
      oss
        .getIndexJson({}, this.id, this.query.timeNo)
        .then((res) => {
          if (res.code == 200) {
            this.setIndexJson(res.data);
            this.$appCommonH.setMainColor(res.data.bgColor);
            this.getAppConfig();
          } else if (res.code == 404) {
            //404活动已下线
            this.$router.replace({ path: "/noLonger" });
          } else if (res.code == 100) {
            //100活动未发布
            this.$toast("该活动暂未发布");
          }
          this.loading = false;
        })
        .catch((err) => {});
    },
    //获取应用配置信息
    getAppConfig() {
      oss.getAppJson({}, this.appId).then(async (res) => {
        // 如果页面在新移sdk内，默认关闭isOutSdk属性，均使用原有逻辑的交互
        let isInSdk = window.xhCloud.outSdkUtils.isInXinhuaSdk();
        // 特殊处理，比如宜昌，在sdk内打开，但需要使用去sdk的配置，这里进行一个后台配置字段isSpecial
        let isSpecial = false;
        let jsInfo = {};
        if (res && !!res.appThirdSdkConfig) {
          if (!!res.appThirdSdkConfig.jsInfo) {
            jsInfo = JSON.parse(res.appThirdSdkConfig.jsInfo);
            isSpecial = jsInfo.isSpecial;
          }
          // 在sdk内打开，开启了三方sdk，并且不需要特殊处理的情况，本地关闭isOutSdk，达到兼容老包情况
          if (isInSdk && !isSpecial) {
            res.appThirdSdkConfig.isOutSdk = 0;
          }
        }
        if (res.appThirdSdkConfig && Object.keys(res.appThirdSdkConfig).length != 0) {
          this.isOutSdk = res.appThirdSdkConfig.isOutSdk;
        }
        console.log("res******************8", res);
        // 初始化三方SDK
        if (res.appThirdSdkConfig && res.appThirdSdkConfig.isOutSdk && !this.isPreview) {
          await this.initOutSdk(res);
          this.isThirdApp = this.$appCommonH.isMyApp(
            JSON.parse(res.appThirdSdkConfig.jsInfo || "{}").outAppUa
          );
        }
        window.isThirdApp = this.isThirdApp;
        //将当前应用配置信息存储在vuex中
        this.setAppData(res);
        console.log("136", res);
        //通过唯一标识设置是否在APP内
        await this.setIsApp(res);
        //设置客户端获取分享数据
        this.setShareData(res);
        //设置客户端登录方法
        if (this.isMyApp) {
          await this.setLoginMethod(res);
        }
        this.loginCheck();
        // this.show = true;
        this.$refs["wxShareRef"].initShare();
        const isWechatEnvironment =
          brower.version.weixin || this.isWechatMiniProgram;
        if (
          window.isApp ||
          (isWechatEnvironment &&
            this.indexJson.joinType === 1 &&
            this.indexJson.wechatJoin !== 0) ||
          !res.appShareConfig.androidDownloadUrl
        ) {
        } else {
          window.xyTools.createGuide(res);
        }
      });
    },
    //设置应用配置存储
    setAppData(res) {
      let shareInfo = [];
      shareInfo.push({
        name: "shareImage",
        content: this.indexJson.promotionImg ? this.indexJson.promotionImg : res.logo,
      });
      shareInfo.push({ name: "shareTitle", content: this.indexJson.name });
      shareInfo.push({
        name: "shareLink",
        content: encodeURIComponent(
          document.location.href.split("#")[0] +
            "#/home?id=" +
            localStorage.getItem("id") +
            "&appId=" +
            localStorage.getItem("appId") +
            "&timeNo=" +
            localStorage.getItem("timeNo")
        ),
      });
      shareInfo.push({
        name: "description",
        content: this.indexJson.summary ? this.indexJson.summary : "",
      });
      res.shareInfo = shareInfo;
      this.setAppJosn(res);
    },
    //设置是否在app内
    setIsApp(res) {
      return new Promise(async (resolve) => {
        if (res.appEnvConfig) {
          let isMyApp = false;
          console.log("res", res);
          if (res.appEnvConfig.appEnvStatus == 1) {
            if (res.appEnvConfig.uaSign) {
              // 三方sdk的UA从jsInfo中获取
              isMyApp =
                this.isThirdApp || this.$appCommonH.isMyApp(res.appEnvConfig.uaSign);
              // 通过appjson的ua判断是否在自己app中，存入vuex中，使用时直接调用 this.$store.getters.getIsMyApp
              // isMyApp = this.$appCommonH.isMyApp(res.appEnvConfig.uaSign);
              if (process.env.NODE_ENV === "development") {
                isMyApp = true;
              }
              console.log("isMyApp", isMyApp);
              this.setIsMyApp(isMyApp);
              window.isApp = isMyApp;
            }
          }
          if (res.appEnvConfig.appEnvStatus == 2) {
            if (this.$appCommonH.getSystem() == "IOS" && res.appEnvConfig.iosMethod) {
              // 如果是ios手机将appjson返回的ios方法写入页面
              this.setAppMethod(res.appEnvConfig.iosMethod);
            }
            if (
              this.$appCommonH.getSystem() == "Android" &&
              res.appEnvConfig.androidMethod
            ) {
              // 如果是Android手机将appjson返回的Android方法写入页面
              this.setAppMethod(res.appEnvConfig.androidMethod);
            }
            if (window.isApp) {
              this.setIsMyApp(window.isApp);
            }
          }
        }
        // 当前环境是否为小程序环境
        const status = await openInWXMiniprogram();

        if (status != undefined) {
          // 微信小程序微信授权模式不作为客户端处理，避免触发客户端登录。
          const isMiniProgramWxAuth =
            status &&
            this.$appCommonH.isMiniProgramWxAuth();
          this.setIsMyApp(isMiniProgramWxAuth ? false : status);
          this.setIsMiniProgram(status);
          window.isApp = isMiniProgramWxAuth ? false : status;
        } else {
          if (location.href.includes("activity.szjiyun.com")) {
            console.log("冀时办-判断是否为支付宝小程序",this.$appCommonH.isAlipayMiniProgram());
            this.setIsMiniProgram(this.$appCommonH.isAlipayMiniProgram());
          }
        }
        resolve();
      });
    },
    setAppMethod(str) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = str;
      document.getElementsByTagName("body")[0].appendChild(script);
    },
    //设置分享数据
    setShareData(res) {
      if (res.appShareConfig) {
        sessionStorage.setItem("appShareConfig", JSON.stringify(res.appShareConfig));
        if (
          res.appShareConfig.iosShareSwitch == 1 &&
          this.$appCommonH.getSystem() == "IOS"
        ) {
          this.setAppMethod(res.appShareConfig.iosShareCode);
        }
        if (
          res.appShareConfig.androidShareSwitch == 1 &&
          this.$appCommonH.getSystem() == "Android"
        ) {
          this.setAppMethod(res.appShareConfig.androidShareCode);
        }
      }
    },
    //设置客户端登录方法
    async setLoginMethod(res) {
      // 三方客户端登陆
      if (this.isThirdApp) {
        console.log("三方客户端登陆===========");
        // this.setGlobalLoginMethod(() => {
        //   return new Promise((resolve) => {
        //     console.log('260')
        //     this.$set(this.indexJson ,'loginStatus', false);
        //     window.xhCloud.freeLogin({ json: res, complete: () => {
        //       let userInfo = getCookie('user')
        //       if (userInfo) {
        //         this.setCookieJson(JSON.parse(userInfo))
        //       }
        //       this.$set(this.indexJson ,'loginStatus', true);
        //       resolve();
        //     } })
        //   })
        // });
        // openId
        // 冀时办+（支付宝小程序||微信小程序）
        if (
          location.href.includes("activity.szjiyun.com") &&
          (this.$appCommonH.isAlipayMiniProgram() || this.$appCommonH.isWechatMiniProgram())
        ) {
          if (!this.openId) {
            console.log("冀时办小程序-二级页面进入");
            this.$store.commit("SET_LOGIN_READY", true);
            const tk = getCookie("token");
            const userInToken = tk ? window.xhCloud.outSdkUtils.decodeJwtToken(tk) : ""; // 从token中获取用户信息
            if (userInToken) {
              this.setCookieJson(userInToken.userInfo);
            } else {
              let userInfo = decodeURIComponent(getCookie("user"));
              if (userInfo) {
                this.setCookieJson(JSON.parse(userInfo));
              }
            }
            this.$set(this.indexJson, "loginStatus", true);
            EventBus.$emit("login", true);
            return;
          }
        }
        window.xhCloud.freeLogin({
          json: { ...res, application: "entry", tokenType: "token" },
          complete: () => {
            console.log("登录成功，更新isLoginReady状态为true...");
            this.$store.commit("SET_LOGIN_READY", true);
            const tk = getCookie("token");
            const userInToken = tk ? window.xhCloud.outSdkUtils.decodeJwtToken(tk) : ""; // 从token中获取用户信息
            if (userInToken) {
              this.setCookieJson(userInToken.userInfo);
            } else {
              let userInfo = decodeURIComponent(getCookie("user"));
              if (userInfo) {
                this.setCookieJson(JSON.parse(userInfo));
              }
            }

            console.log("loginStatus********************************");
            this.$set(this.indexJson, "loginStatus", true);
            console.log("indexJson********************************", this.indexJson);
            EventBus.$emit("login", true);
            // resolve();
          },
        });
        return false;
      }
      if (!res.appLoginConfig) {
        return false;
      }
      if (res.appLoginConfig.hasAppLogin == 1 && res.appLoginConfig.appLoginWay) {
        this.setGlobalLoginMethod(res.appLoginConfig.appLoginWay);
        return false;
      }
      if (res.appLoginConfig.hasH5Login == 1 && res.appLoginConfig.h5LoginWay) {
        window.location.href = res.appLoginConfig.h5LoginWay;
        return false;
      }
    },
    //全局登录方法
    setGlobalLoginMethod(str) {
      let f = new Function("return " + str);
      window.ryUserLogin = f();
    },
    loginCheck() {
      // 用户登录
      let status = this.mixLogin();
      // 用户已登录
      if (status) return this.setVisitLog();
      // if (!status) this.$router.push({ name: "connotAccess" }); // 非app 和微信环境 跳转错误页面
    },
    /**
     * 记录浏览量
     */
    setVisitLog() {
      //预览不调用
      if (this.isPreview) {
        return false;
      }
      let platform = "";
      let config = {
        ios: "ios",
        android: "android",
        h5: "h5",
      };

      if (
        this.isMyApp &&
        (brower.version.ios || brower.version.iPhone || brower.version.iPad)
      ) {
        platform = config.ios;
      } else if (this.isMyApp && brower.version.android) {
        platform = config.android;
      } else {
        platform = config.h5;
      }
      if (!platform) {
        return false;
      }

      try {
        let obj = this.$appCommonH.getRequestParamObj();
        const timeStamp = Date.parse(new Date());
        let params = {
          type: "entry",
          id: obj.id,
          platform: platform,
          currentTimeMillis: timeStamp,
          cid: obj.appId,
          signature: "",
        };
        wxApi.addVisitLog(params);
      } catch (e) {
        console.log(e);
      }
    },
    onBack() {
      if (location.href.indexOf("home") > -1) {
        if (this.isOutSdk) {
          window.xhCloud.pageReturn();
        } else {
          ClientApi.getInstance().JSCallNative("pageReturn");
        }
      } else {
        window.history.go(-1);
      }
    },
    /** 初始化三方SDK */
    initOutSdk(jsonData) {
      return new Promise((resolve) => {
        window.xhCloud.loadOutSdk({ json: jsonData, complete: resolve });
      });
    },
    initSliderSdk() {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://www.media.xinhuamm.net/js/xinhua-sdk/captcha.load.min.js";
      document.getElementsByTagName("body")[0].appendChild(script);
      console.log("滑块sdk加载完成", script);
    },
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
.back {
  position: fixed;
  bottom: 62px;
  left: 16px;
  z-index: 10000;
  font-size: 0.45rem;
  color: #666;
  .circle {
    display: inline-flex;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    background: url(assets/images/icon_back.png) no-repeat;
    background-size: 100% auto;
  }
}

.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.46rem;
  position: fixed;
  z-index: 10000;
  top: 0;
  background: rgba(0, 0, 0, 0.6);

  .left-line {
    width: 0.64rem;
    height: 0.02rem;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    border-radius: 0.01rem;
    opacity: 0.5;
  }

  .tips {
    font-size: 0.16rem;
    font-weight: 500;
    color: #ffffff;
    margin: 0 0.1rem;
  }

  .right-line {
    width: 0.64rem;
    height: 0.02rem;
    background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 0.01rem;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue